(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('WorkingSchedulesController', WorkingSchedulesController);

  /** @ngInject */
  function WorkingSchedulesController(
    layoutActions,
    $translate,
    organizationActions,
    workingSchedulesActions,
    dashboardKarcherActions,
    fromArrayToPathParam,
    brand
  ) {
    var vm = this;

    vm.placeHolderText = $translate.instant('SITE_NAME');
    vm.deviceListPlaceHolder = $translate.instant('DEVICES_INFO');
    vm.deviceId = '';
    vm.brand = brand;

    init();

    vm.getSchedulesForSiteId = function (id) {
      vm.siteId = id;
      getDevicesList(id);
      vm.refreshHolidayList();
      vm.refreshSchedules();
    };

    vm.clearSiteInput = function () {
      vm.siteId = '';
      vm.scheduleList = [];
      vm.holidayList = [];
    };

    vm.clearDevicesInput = function () {
      vm.deviceId = '';
    };

    vm.getDevicesId = function (id) {
      vm.deviceId = id;
    };

    vm.propagate = function () {
      layoutActions.showLoader();
      var path = fromArrayToPathParam.createOnlyPath(
        vm.deviceId,
        'deviceKey='
      );
      workingSchedulesActions
        .propagateWorkingSchedules(vm.siteId, path)
        .then(function () {
          layoutActions.hideLoader();
        });
    };

    function init() {
      vm.scheduleList = [];
      vm.holidayList = [];
      layoutActions.showLoader();
      organizationActions.getAllSitesForExactUser().then(function (response) {
        vm.siteList = response;
      });
      layoutActions.hideLoader();
    }
    function getDevicesList(siteId) {
      dashboardKarcherActions
        .getKarcherSiteDetailsById(siteId)
        .then(function (response) {
          vm.devicesList = response.map(function (device) {
            return {
              name: device.pointName,
              id: device.deviceKey
            };
          });
        });
    }

    vm.refreshHolidayList = function () {
      layoutActions.showLoader();
      workingSchedulesActions
        .getSiteHolidays(vm.siteId)
        .then(function (holidays) {
          vm.holidayList = holidays;
          layoutActions.hideLoader();
        });
    };

    vm.refreshSchedules = function () {
      layoutActions.showLoader();
      workingSchedulesActions
        .getWorkingSchedules(vm.siteId)
        .then(function (schedules) {
          vm.scheduleList = schedules.days;
          vm.allDayCheckBoxData = schedules.state24h;
          layoutActions.hideLoader();
        });
    };
  }
})();
